/* eslint-disable max-len */
import React, { SVGAttributes } from 'react';

export default ({ color = '#FFF', ...props }: SVGAttributes<SVGElement> & { color?: string }) => (
	<svg width="24px" viewBox="0 0 24 24" {...props}>
		<path
			fill={color}
			fillRule="evenodd"
			d="M12 5.1L13.94 9.93L19.13 10.28L15.14 13.62L16.41 18.67L12 15.9L7.59 18.67L8.86 13.62L4.87 10.28L10.06 9.93ZM10.75 10.89L7.42 11.11L9.98 13.25L9.17 16.5L12 14.72L14.83 16.5L14.02 13.25L16.58 11.11L13.25 10.89L12 7.78Z"
		/>
	</svg>
);
